export default __webpack_public_path__ + "static/media/seller_filled.09db77c7.svg";